module.exports = __webpack_public_path__ + "static/img/organ.2981d16.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/organ.gif
// module id = F7u3
// module chunks = 1